import React, { Component } from "react";
import {
    Card,
    CardBody,
    Col,
    Collapse,
    Container,
    Row,
} from "reactstrap";
import { Link } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../../../../components/Common/Breadcrumb";
import { get_user_permissions } from "helpers/custom_helper";
var documentTemplatesLogs;
class TabView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "1",
            activeTab1: "5",
            activeTab2: "9",
            activeTab3: "13",
            verticalActiveTab: "1",
            verticalActiveTabWithIcon: "1",
            customActiveTab: "1",
            customIconActiveTab: "1",
            activeTabJustify: "5",
            col1: true,
            col2: false,
            col3: false,
        };
        this.t_col1 = this.t_col1.bind(this);
        this.t_col2 = this.t_col2.bind(this);
        this.t_col3 = this.t_col3.bind(this);
    }

    t_col1() {
        this.setState({
            col1: !this.state.col1,
            col2: false,
            col3: false,
        });
    }

    t_col2() {
        this.setState({
            col1: false,
            col2: !this.state.col2,
            col3: false,
        });
    }

    t_col3() {
        this.setState({
            col1: false,
            col2: false,
            col3: !this.state.col3,
        });
    }
    render() {
        //meta title
        document.title = "Tab View";
        documentTemplatesLogs = get_user_permissions("document-templates-logs-view");
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid={true}>
                        <Breadcrumbs
                            title="Documents Templates"
                            breadcrumbItem="Financials Templates"
                        />
                        <Row>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col lg={12}>
                                            {/* <CardTitle className="h4 mb-4 mt-2">Sales Templates</CardTitle> */}
                                            <div className="accordion" id="accordion">
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingOne">
                                                        <button
                                                            className="accordion-button fw-medium"
                                                            type="button"
                                                            onClick={this.t_col1}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            Invoice
                                                        </button>
                                                    </h2>

                                                    <Collapse
                                                        isOpen={this.state.col1}
                                                        className="accordion-collapse"
                                                    >
                                                        <div className="accordion-body">
                                                            <div className="text-dark">
                                                                <Link to="/template/documents/financials/invoice/samples-list">
                                                                    <p>
                                                                        <i className="mdi mdi-chevron-right text-primary me-1"></i>
                                                                        Samples Templates
                                                                    </p>
                                                                </Link>
                                                                <Link to="/template/documents/financials/invoice/clone-list">
                                                                    <p>
                                                                        <i className="mdi mdi-chevron-right text-primary me-1"></i>
                                                                        List Cloned Templates
                                                                    </p>
                                                                </Link>
                                                                {documentTemplatesLogs ? <>
                                                                    <Link to="/template/documents/financials/invoice/logs">
                                                                        <p>
                                                                            <i className="mdi mdi-chevron-right text-primary me-1"></i>
                                                                            Logs
                                                                        </p>
                                                                    </Link>
                                                                </> : <></>}
                                                            </div>
                                                        </div>
                                                    </Collapse>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingTwo">
                                                        <button
                                                            className="accordion-button fw-medium collapsed"
                                                            type="button"
                                                            onClick={this.t_col2}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            Receipt
                                                        </button>
                                                    </h2>

                                                    <Collapse
                                                        isOpen={this.state.col2}
                                                        className="accordion-collapse"
                                                    >
                                                        <div className="accordion-body">
                                                            <div className="text-dark">
                                                                <Link to="/template/documents/financials/receipt/samples-list">
                                                                    <p>
                                                                        <i className="mdi mdi-chevron-right text-primary me-1"></i>
                                                                        Samples Templates
                                                                    </p>
                                                                </Link>
                                                                <Link to="/template/documents/financials/receipt/clone-list">
                                                                    <p>
                                                                        <i className="mdi mdi-chevron-right text-primary me-1"></i>
                                                                        List Cloned Templates
                                                                    </p>
                                                                </Link>
                                                                {documentTemplatesLogs ? <>
                                                                    <Link to="/template/documents/financials/receipt/logs">
                                                                        <p>
                                                                            <i className="mdi mdi-chevron-right text-primary me-1"></i>
                                                                            Logs
                                                                        </p>
                                                                    </Link>
                                                                </> : <></>}
                                                            </div>
                                                        </div>
                                                    </Collapse>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Row>

                    </Container >
                </div >
            </React.Fragment >
        );
    }
}
export default TabView;
